import React from 'react';
import styles from './loader.module.css';

const Loader = ( { small } ) => {
    if( small ) return <div className={styles.loader}></div>
    return <div className={styles.central}><div className={styles.loader}></div></div>
}

export default  Loader
